module.exports = __webpack_public_path__ + "img/scanner.401449ba.png";